<template>
  <div class="container-dz">
    <vue-dropzone
      id="dropzone"
      ref="dropzone"
      :options="dropzoneOptions"
      class="h-full w-full has-text-centered"
      @vdropzone-error="onDropzoneError"
      @vdropzone-success="onDropzoneSuccess"
      @vdropzone-removed-file="onDropzoneRemove"
    />
  </div>
</template>

<script>
  import { getToken } from "utils/auth";

  export default {
    name: "Dropzone",
    props: {
      data: {
        default: () => [],
        type: Array,
      },
      featured: String,
    },
    data() {
      return {
        galleries: this.data,
        dropzoneOptions: {
          url: config.apiUrl + "/media/multi-upload",
          paramName: "file",
          maxFilesize: 1,
          thumbnailWidth: 200,
          thumbnailHeight: null,
          acceptedFiles: "image/*",
          addRemoveLinks: true,
          dictDefaultMessage: "",
          headers: {
            Authorization: "Bearer " + getToken(),
          },
          previewTemplate: this.template(),
          maxFiles: 1,
          uploadMultiple: false,
        },
      };
    },
    watch: {
      data: {
        handler() {
          if (this.galleries.length === 0) {
            this.galleries = this.data;
            if (this.galleries.length > 0) {
              this.galleries.forEach((el) => {
                this.$refs.dropzone.manuallyAddFile({ id: el }, el);
              });
              this.setImageClickEvent();

              if (this.featured) {
                let i = this.galleries.indexOf(this.featured);
                if (i >= 0) {
                  $("#dropzone")
                    .children()
                    .eq(i + 1)
                    .addClass("dropzone-featured");
                }
              }
            }
          }
        },
        deep: true,
      },
    },
    mounted() {
      const dzMessage = document.getElementsByClassName("dz-message");

      if (dzMessage) {
        for (let item of dzMessage) {
          item.style.margin = "0px";
          item.style.height = "200px";
          item.innerHTML = `
    <div class="img-placeholder">
      <i  class='fa fa-cloud-upload img-logo-up'></i>
      <div style="font-weight: bold; color: lightgray">Drop an image here or click to upload</div>
    </div>`;
        }
      }
    },
    methods: {
      template() {
        return `<div class="dz-preview dz-file-preview " >
<div class="dz-image"><img data-dz-thumbnail class="thumbnail-img" /></div>
  <div class="dz-details">

  </div>
  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
  <div class="dz-success-mark"><svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Check</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path></g></svg></div>
  <div class="dz-error-mark">    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Error</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path></g></g></svg></div>
  <div class="dz-error-message"><span data-dz-errormessage></span></div>
</div>

        `;
      },
      onDropzoneError(file, message) {
        let errors = message.error.message;
        if (message.error.errors) {
          let arr = [];
          for (let key in message.error.errors) {
            arr.push(message.error.errors[key]);
          }
          errors = arr.join();
        }
        $(".dz-error-message span").text(errors);
      },
      onDropzoneSuccess(file, res) {
        file.id = res.data[0].full_url;
        this.galleries.push(res.data[0].full_url);
        this.$emit("input", this.galleries);
        this.setImageClickEvent();
      },
      onDropzoneRemove(file) {
        this.$emit("remove", file.id);
        this.galleries.splice(this.galleries.indexOf(file.id), 1);
        this.$emit("input", this.galleries);
        this.setImageClickEvent();
      },
      setImageClickEvent() {
        let me = this;
        $(".btn-test").unbind("click");
        $(".btn-test").click(function () {
          me.setFeaturedImage(
            $(".dz-image-preview").index($(this).parent().parent())
          );
        });
      },
      setFeaturedImage(index) {
        this.$emit("featured", this.galleries[index]);
        this.clearFeaturedMask();
        $("#dropzone")
          .children()
          .eq(index + 1)
          .addClass("dropzone-featured");
      },
      clearFeaturedMask() {
        for (let i = 1; i < $("#dropzone").children().length; i++) {
          $("#dropzone").children().eq(i).removeClass("dropzone-featured");
        }
      },
    },
  };
</script>

<style lang="scss">
  .dropzone {
    padding: unset;

    .dropzone-featured::before {
      content: "\A";
      border-style: solid;
      border-width: 0 30px 20px 0;
      border-color: transparent #00d1b2 transparent transparent;
      position: absolute;
      right: 0;
      z-index: 100;
    }

    .dz-preview {
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 100%;
      margin: 0;
    }
  }

  .thumbnail-img {
    min-height: 200px;
    max-height: 200px;
    max-width: none !important;
    width: 100% !important;
    object-fit: contain;
  }

  .bg-dz {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .img-placeholder {
    position: relative;
    height: 200px;
    background-color: rgba(211, 211, 211, 0.3);
  }

  .dz-preview {
    height: 200px;
    min-height: 200px;
    max-height: 200px;
  }

  .dz-drag-hover {
    border: 2px dashed #e2e2e2 !important;
    opacity: 1;
  }

  .vue-dropzone:hover {
    border: 2px dashed #e2e2e2 !important;
    background-color: rgba(255, 255, 255, 0.5) !important;
    opacity: 0.65;
  }

  .img-logo-up {
    font-size: 60px;
    margin-top: 65px;
  }
</style>

<style scoped>
  .container-dz {
    max-height: 500px;
    overflow: auto;
    width: 100%;
  }
</style>
